import React, { Component } from 'react';
import { Nav, NavItem, Navbar } from 'react-bootstrap';
import Filters from './filters/Filters';
import SitesMap from './map/SitesMap';
import SitesPane from './table/SitesPane';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import markerJSON from './assets/data/sites.json';


export class WatershedSFA extends Component {
    constructor(props) {
        super(props);

        this.state = {container: false};
        this.containerRendered = this.containerRendered.bind(this);
    }
    
    containerRendered() {
        this.setState({container: true});
    }
    
    componentDidMount() {
        document.documentElement.className = 'app';
        document.body.className = 'app';
    }
 
    render() {     
        return (
            <div>
                <div className="container-fluid">
                    {this.state.container &&
                    <div>
                        <div id='navbar'>
                            <Header />
                        </div>
                        <div>
                        <Description />
                        </div>
                    </div>
                    }
                    <SitesContainer data={markerJSON} hasRendered={this.containerRendered} />
                </div>
            </div>
        );
    }
}

export class Header extends Component {
    render() {
        let logo = require("./assets/images/SFA_WatershedFunction.jpg");
        
        return (
            <Navbar inverse fluid>
                <Navbar.Header>
                    <div className="pull-left">
                        <img id='logo' alt="SFA Logo" src={logo}/>
                    </div>
                    <Navbar.Brand>
                        <a href="http://watershed.lbl.gov">
                            <span>Watershed Function SFA</span>
                        </a>
                    </Navbar.Brand>
                </Navbar.Header>
                <Nav>
                    <NavItem active>
                        <span>Field Information Portal</span>
                    </NavItem>
                    <NavItem href={window.location.origin}>
                        <span>Data Access</span>
                    </NavItem>
                    <NavItem href="https://lbnlsfa.paf.subsurfaceinsights.com/datapackages" target="_blank">
                        <span>Data Package System</span>
                    </NavItem>
                    <NavItem href="https://drive.google.com/file/d/0Bz9Zv4YIp0kPVnpZTkRNb0ZyQ2tTdEFZX0xwc05QX0VzRDFj/view">
                        <span>Data Policy</span>
                    </NavItem>
                    <NavItem href={window.location.origin + "/feedback"}>
                        <span>Feedback</span>
                    </NavItem>
                </Nav>
            </Navbar>
        )
    }
}

class Description extends Component {
    render() {
        return (
            <div className="row" id="description">
                <div className="col-xs-12">
                    <div>
                        <h3>Field Information Portal</h3>
                    </div>
                    <div>
                        <p>The East River Watershed Function SFA study site provides a collaborative platform that enables the broader scientific community to address a range of questions relevant to watershed structure and behavior. The interactive map below identifies sites where the SFA team and collaborators are acquiring different types of measurements within the watershed.</p>
                    </div>
                </div>
            </div>
        );
    }
}

class SitesContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sites: this.props.data,
            active: this.props.data.features[0],
            filters: {measurement_categories: new Set(), search_keywords: []}
        };
        this.handleCategoryFilterInput = this.handleCategoryFilterInput.bind(this);
        this.handleSearchFilterInput = this.handleSearchFilterInput.bind(this);
        this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
        this.handleMapInput = this.handleMapInput.bind(this);
        this.handleTableInput = this.handleTableInput.bind(this);
        this.markerActivated = this.markerActivated.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        
        this.hasRendered = props.hasRendered.bind(this);
    }
    
    handleCategoryFilterInput(categories) {
        let filters = {
            measurement_categories: categories,
            search_keywords: this.state.filters.search_keywords
        };
        this.setState({filters: filters});
        this.applyFilters(filters);
    }

    handleSearchFilterInput(text) {
        if (text === "") {
            this.applyFilters({
                measurement_categories: this.state.filters.measurement_categories,
                search_keywords: []
            });
            return;
        }
        
        clearTimeout(this.searchTimeout);

        if (text.trim().length < 3) {
            return;
        }

        const self = this;
        this.searchTimeout = setTimeout(function () {
            let keywords = text.split(' ');
            let filters = {
                measurement_categories: self.state.filters.measurement_categories,
                search_keywords: keywords
            };
            self.setState({search_keywords: keywords});
            self.applyFilters(filters);
        }, 500);
    }
    
    handleSearchSubmit(text) {
        let keywords = text.split(' ');
        let filters = {
            measurement_categories: this.state.filters.measurement_categories,
            search_keywords: keywords
        };
        this.applyFilters(filters);
    }
    
    applyFilters(filters) {
        let filteredSites = {
            type: this.props.data.type,
            features: this.props.data.features.filter(function (val) {              
                if (filters.measurement_categories.size === 0 && filters.search_keywords.length === 0) {
                    return true;
                }
                
                let found = false;
                if (filters.measurement_categories.size === 0) {
                    found = true;
                }
                else {
                    for (var i = val.properties.measurement_categories.length - 1; i >= 0; i--) {
                        found = found || filters.measurement_categories.has(val.properties.measurement_categories[i]);
                    }
                }
                
                // test a regex against a string
                function match_words(s, re) {
                    let m = false;
                    
                    if (s) {
                        // split the string into words, try to match each word
                        // any word match is enough
                        s.toString().split(' ').forEach(function (item) {
                            m = m || item.match(re) !== null;
                        });
                        return m;
                    }
                    else {
                        return false;
                    }
                }
                
                let re, matched = {};
                for (let i = 0; i < filters.search_keywords.length; i++) {
                    //escape all regex characters in the search text
                    re = new RegExp('^' + filters.search_keywords[i].replace(/[#-.]|[[-^]|[?|{}]/g, '\\$&'), 'i');

                    matched.id = match_words(val.properties.id, re);
                    matched.name = match_words(val.properties.name, re);
                    matched.parameters = match_words(val.properties.parameters, re);
                    matched.category = match_words(val.properties.category, re);
                    matched.theme = match_words(val.properties.research_theme, re);
                    matched.contact = match_words(val.properties.contact.name, re);
                    matched.affiliation = match_words(val.properties.contact.affiliation, re);

                    // if the keyword matches at least one field
                    found = found && (matched.id ||
                                      matched.name ||
                                      matched.parameters ||
                                      matched.category ||
                                      matched.theme ||
                                      matched.contact ||
                                      matched.affiliation);                    
                }
                
                // if all keywords had at least one field match, keep this site
                return found;
            })
        };

        this.setState({
            sites: filteredSites,
            active: filteredSites.features.length > 0 ? filteredSites.features[0] : null
        });        
    }
    
    markerActivated(feature) {
        this.setState({active: feature});
    }

    handleMapInput(mapState) {
        console.log(mapState);
    }
    
    handleTableInput(id) {
        for (let i = this.state.sites.features.length - 1; i >= 0; i--) {
            if (this.state.sites.features[i].id === id) {
                this.setState({active: this.state.sites.features[i]});
                break;
            }
        }
    }
    
    componentDidMount() {
        this.setState({
            active: this.props.data.features[0],
            sites: this.props.data
        });
        this.hasRendered();
    }
    
    render() {
        return (
            <div className="row">
                <Filters onCategoryFilterInput={this.handleCategoryFilterInput}
                         onSearchFilterInput={this.handleSearchFilterInput}
                         onSearchSubmit={this.handleSearchSubmit}/>
                <SitesMap sites={this.state.sites}
                          activeSite={this.state.active}
                          markerActivated={this.markerActivated}
                          onMapInput={this.handleMapInput}/>
                <SitesPane sites={this.state.sites}
                           activeSite={this.state.active}
                           totalSites={this.props.data.features.length}
                           onTableInput={this.handleTableInput}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/App.js